import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h3 className="text-sm font-semibold mb-2" style={{ color: '#f0c040' }}>{title}</h3>
    <div className="text-sm leading-relaxed space-y-2" style={{ color: 'rgba(255,255,255,0.7)' }}>
      {children}
    </div>
  </div>
);

const P = ({ children }) => <p>{children}</p>;

const Li = ({ children }) => (
  <li className="flex gap-2">
    <span style={{ color: '#d4a017' }}>•</span>
    <span>{children}</span>
  </li>
);

const Ul = ({ children }) => <ul className="space-y-1.5 pl-1">{children}</ul>;

export { Section, P, Li, Ul };

export default function PolicyLayout({ title, subtitle, icon: Icon, updatedAt = 'February 2026', children }) {
  const navigate = useNavigate();

  return (
    <div className="app-shell flex flex-col min-h-screen">

      {/* Sticky Header */}
      <div
        className="sticky top-0 z-20 flex items-center gap-3 px-4 py-4 border-b"
        style={{
          background: 'rgba(15,27,80,0.95)',
          backdropFilter: 'blur(12px)',
          borderColor: 'rgba(212,160,23,0.15)',
        }}
      >
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(255,255,255,0.08)' }}
        >
          <ArrowLeft size={18} color="rgba(255,255,255,0.8)" />
        </button>
        <div>
          <h1 className="text-base font-serif font-bold text-white leading-tight">{title}</h1>
          <p className="text-[11px]" style={{ color: 'rgba(255,255,255,0.4)' }}>
            Shine Jewellery · Last updated {updatedAt}
          </p>
        </div>
      </div>

      {/* Hero banner */}
      <div
        className="mx-4 mt-5 mb-4 rounded-2xl px-4 py-4 border flex items-center gap-3"
        style={{
          background: 'rgba(212,160,23,0.08)',
          borderColor: 'rgba(212,160,23,0.22)',
        }}
      >
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: 'linear-gradient(135deg, #d4a017, #f0c040)' }}
        >
          <Icon size={18} color="#fff" />
        </div>
        <div>
          <p className="text-sm font-semibold text-white">{title}</p>
          <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.5)' }}>{subtitle}</p>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-4 pb-10">
        {children}
      </div>

      {/* Footer */}
      <div
        className="px-4 py-5 border-t text-center"
        style={{ borderColor: 'rgba(255,255,255,0.07)' }}
      >
        <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
          © 2026 Shine Jewellery · All Rights Reserved
        </p>
        <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.2)' }}>
          support@shinejewellery.in
        </p>
      </div>

    </div>
  );
}
